<template>
   <div class="done_wrap">
    <div class="container-fluid-xl">
		   <div class="row">
           <div class="col-lg-8">
        <img src="~@/assets/done_o.png" alt="success_order">
       <p>{{get_local_string.string_105}}{{get_object_result_pay_done.code}} .</p>
          <b-button class="new_color" tag="router-link" to="/meny">{{get_local_string.string_106}}</b-button>
           </div>
           <div class="col-lg-4 invoiceC">
                <div class="invoice">
                    <div class="invoice-card">
                        <div class="invoice-title">
                            <div id="main-title">
                               <h4>{{get_local_string.string_93}}</h4>
								<span class="orno">#{{get_object_result_pay_done.code}}
                  <span v-if="get_object_result_pay_done.coupon.code" class="abs_dis">{{get_object_result_pay_done.coupon.title}}</span>
                </span>
                            </div>
                            <span id="date">{{get_object_result_pay_done.date}}</span>
                        </div>
                        <div class="invoice-details">
                            <table class="invoice-table">
                                <thead>
                                    <tr>
                                        <td class="left_td">{{get_local_string.string_107}}</td>
                                        <td>{{get_local_string.string_108}}</td>
                                        <td class="right_tit">{{get_local_string.string_62}}</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="row-data" v-for="product in get_object_result_pay_done.product_list" :key="product.id">
                                        <td class="left_td">{{product.name}}</td>
                                        <td id="unit">{{product.qty}}</td>
                                        <td class="right_td">{{product.item_total}}{{get_setting_app.payment.currency}}
                                          <del v-if="get_object_result_pay_done.coupon.code">{{product.old_item_total}}{{get_setting_app.payment.currency}}</del>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="invoice-details offers">
                            <table class="invoice-table">
                                <tbody>
                                    <tr class="row-data">
                                        <td class="left_td">{{get_local_string.string_109}}</td>
                                        <td id="optinal"></td>
                                        <td class="right_td">{{get_object_result_pay_done.sub_total}} {{get_setting_app.payment.currency}}</td>
                                    </tr>

                                    <tr class="row-data" v-for="vat in get_object_result_pay_done.vat" :key="vat.id">
                                       <td class="left_td">{{get_local_string.string_110}} {{vat.tax_rate}}%</td>
                                        <td id="optinal"></td>
                                        <td class="right_td">{{vat.tax_total}} {{get_setting_app.payment.currency}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="invoice-footer">
                             <span class="total">{{get_local_string.string_56}}</span>
                            <span class="total_price">{{get_object_result_pay_done.total}} {{get_setting_app.payment.currency}}</span>
                        </div>
                    </div>
                </div>
            </div>
         
   </div>
	</div>
   </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
    name:'done_order_app',
    computed:{
        ...mapGetters({
            get_object_result_pay_done:'get_object_result_pay_done',
			 get_setting_app:'get_setting_app',
        get_local_string:'get_local_string'
        })
    },
    methods:{
        access_with_out_order(){
            console.log(this.get_object_result_pay_done)
            if(Object.keys(this.get_object_result_pay_done).length === 0) {
                this.$router.replace('/login');
            }
        }
    },
    mounted(){
        console.log('mount page');
        // this.access_with_out_order();
    }
}
</script>
<style lang="scss">
.new_color{
  background-color: var(--side_color) !important;
  color: white !important;
  transition: 0.2s ease-in-out;
  border: 1px solid white;
  cursor: pointer;
  &:hover{
   background-color: darken($color: #77182F, $amount: 10%) !important;
  }
}
</style>
<style lang="scss" scoped>
.abs_dis{
      position: absolute;
    top: 10px;
    right: 20px;
    font-size: 14px;
    color: #7ac043;
    font-weight: 500;
}
.done_wrap{
       padding: 100px 20px 30px 20px;
    text-align: center;
    color: black;
    position: relative;
    z-index: 1;
    img{
        width: 500px;
    }
    p{
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 20px;
        color: #fff;
    }

.right_td{
text-align: right !important;
    padding-right: 20px;
}
.left_td{
text-align: left !important;
    // padding-right: 20px;
}
.right_tit{
	text-align: right !important;
    padding-right: 30px;
}

}

// invoice page

/* invoice*/

 /*strat Invoce code */
.InvoiceBtn{
  position: fixed;
    right: -70px;
    display: none;
    top: 50%;
    z-index: 9999;
    transform: rotate(
90deg
);
    font-size: 25px;
    background-color: #221d1d;
    color: white;
    padding: 6px 12px;
    cursor: pointer;
    font-weight: 500;
}
.uk-close {
  color: #a80e0e;
  transition: .1s ease-in-out;
  transition-property: color,opacity;
  background-color: white;
  border-radius: 50%;
}
[class*=uk-modal-close-] {
  position: absolute;
  z-index: 1010;
  top: 45px;
  right: -15px;
  padding: 5px;
}

 .invoice{
    margin-top: 114px;
    position: relative;
    z-index: 99;
    animation: fadeInDown ;
    animation-duration: 1.5s;
    animation-delay: 1s;
}
.invoice::before{
    content: '';
    position: absolute;
    top: -10px;
    left: -2.2%;
    background-color: #353433;
    height: 30px;
    width: 104%;
    z-index: -1;
    border-radius: 50px;
}
 .invoice-card {
    display: flex;
    flex-direction: column;
    padding: 10px 1em;
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0px 10px 30px 5px rgba(0, 0, 0, 0.15);
  }

  .invoice-card > div {
    margin: 5px 0;
    text-align: left;
    direction: ltr;
  }

  .invoice-title {
    flex: 3;
  }

  .invoice-title #date {
    display: block;
    margin: 8px 0;
    font-size: 12px;
  }

  .invoice-title #main-title {
    display: flex;
    justify-content: space-between;
    margin-top: 2em;
	align-content: center;
	align-items: center;
	.orno{
		font-size: 22px;
		font-weight: 500;
	}
  }

  .invoice-title #main-title h4 {
    font-size: 36px;
    font-family: 'El Messiri', sans-serif !important;
  }


  .invoice-details {
    flex: 1;
    border-top: 0.5px dashed grey;
    border-bottom: 0.5px dashed grey;
    display: flex;
    align-items: center;
  }
  .offers{
    border-top:none;
  }

  .invoice-table {
    width: 100%;
    border-collapse: collapse;
  }

  .invoice-table thead tr td {
    font-size: 12px;
    color: grey;
    padding: 8px 0;
  }

  .invoice-table thead tr td:nth-last-child(1),
  .row-data td:nth-last-child(1),
  .calc-row td:nth-last-child(1)
  {
    text-align: right;
  }

  .invoice-table tbody tr td {
      padding: 8px 0;
      letter-spacing: 0;
  }

  .invoice-table .row-data #unit {
    text-align: center;
  }

  .invoice-table .row-data span {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.6);
  }

  .invoice-footer {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .invoice-footer .total,.invoice-footer .total_price{
    font-size: 24px;
    font-weight: 700;
  }
  .invoice-footer #later {
    margin-right: 5px;
  }

/*end */

// end 
@media(max-width:767px){
  .done_wrap{
    img{
        width: auto !important;
    }
    p{
        font-size: 13px;
        font-weight: 600;
    }
  }  
}
</style>